import { isTrustedResourceUrl } from './isTrustedUrl'

export function createBobWidgetFactory(baseUrl, onInit) {
	if (!isTrustedResourceUrl(baseUrl)) {
		return undefined
	}
	return window.auth.bridge.init(
		{
			baseUrl,
		},
		onInit,
	)
}

export function getBobLoginWidgetForOrigin(
	baseUrl,
	forgotUsernameUrl,
	bobServiceType,
) {
	return () => {
		if (
			!isTrustedResourceUrl(baseUrl) ||
			!isTrustedResourceUrl(forgotUsernameUrl)
		) {
			return undefined
		}
		return window.auth.bridge.loginWidget.get({
			appendTo: '#loginWidgetContainer',
			baseUrl,
			forgotUsernameUrl,
			saveUsername: false,
			showTitle: true,
			signUp: false,
			submitText: 'Sign On',
			titleText: 'Sign On',
			serviceType: bobServiceType,
			origin: 'cob',
		})
	}
}
